import { Caption } from 'react-native-paper';
import styled from 'styled-components/native';

import Button from '@src/components/Button';
import KeyboardAvoidingView from '@src/components/KeyboardAvoidingView';
import { H1 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';

export const Remaining = styled(Caption)`
  text-align: center;
  padding: ${padding}px;
`;

export const ResendCodeButton = styled(Button).attrs(({ theme }) => ({
  mode: 'text',
  color: theme.colors.primary,
  uppercase: false,
  compact: true,
}))``;

export const Container = styled(KeyboardAvoidingView).attrs(() => ({
  contentContainerStyle: {
    flex: 1,
    justifyContent: 'space-between',
    padding,
  },
}))`
  flex: 1;
  justify-content: space-between;
`;

export const Wrapper = styled.View``;

export const RTLContainer = styled(Container)`
  align-items: flex-start;
  margin-top: 40px;
`;

export const TextButton = styled(Button).attrs(() => ({
  uppercase: false,
  mode: 'text',
  contentStyle: {
    alignItems: 'center',
    paddingStart: 30,
  },
}))``;

export const Title = styled(H1)`
  margin-bottom: 20px;
  padding: 0px ${padding}px;
`;
